<div class="app-container d-flex">
  <!-- Mobile Menu Toggle Button -->
  <!-- Mobile Menu Show Button (only shows when sidebar is closed) -->


  <!-- Mobile Backdrop -->
  <div class="mobile-backdrop" [ngClass]="{ 'active': isMobileSidebarActive }" (click)="closeMobileSidebar()"></div>

  <div class="sidebar-resizable-container" [style.width.px]="sidebarWidth" [ngClass]="{ 
      'sidebar-hidden-drag': isSidebarHidden && !isMobileView,
      'mobile-sidebar-active': isMobileSidebarActive && isMobileView
    }">
    <app-sidebar [isSidebarHidden]="isSidebarHidden" [chatSessions]="chatSessions" [currentSessionId]="currentSessionId"
      [isMobileView]="isMobileView" [availableModels]="models" [selectedModel]="selectdModel"
      [creativityValue]="selectdTemperature" [selectedReasoning]="selectedReasoning" (newChat)="handleNewChat()"
      (sessionLoaded)="loadSessionById($event)" (sessionDeleted)="handleSessionDeleted($event)"
      (sessionEdited)="handleSessionEdited($event)" (closeMobileSidebar)="closeMobileSidebar()"
      (modelChange)="onSidebarModelChange($event)" (creativityChange)="onSidebarCreativityChange($event)"
      (reasoningChange)="onSidebarReasoningChange($event)" #sideContainer (sessionShared)="handleSessionShared($event)">
    </app-sidebar>
  </div>

  <div class="sidebar-resizer" (mousedown)="onMouseDown($event)"></div>

  <div class="main-chat-area chat-messages-container flex-grow-1" #chatContainer>
    <div class="chat-content-wrapper">
      <nav id="nav">
        <div class="logo">
          <div class="nav-content">
            <div (click)="toggleSidebar()" style="cursor: pointer">

              <!-- Show Expand Icon when sidebar is hidden -->
              @if (isSidebarHidden) {
                <svg xmlns="http://www.w3.org/2000/svg" width="30"
                  height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" style="color: #333; font-size: 30px;"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-layout-sidebar-left-expand">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                  <path d="M9 4v16" />
                  <path d="M14 10l2 2l-2 2" />
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  style="color: #333; font-size: 30px;"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-layout-sidebar-left-collapse">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                  <path d="M9 4v16" />
                  <path d="M15 10l-2 2l2 2" />
                </svg>
              }

              <!-- Collapse Icon when sidebar is visible -->


            </div>

            <!-- HC AI Badge -->
            <div class="header-badge">
              <img src="../../assets/img/GPT1.jpeg" alt="HC" class="header-badge-logo" />
              <span class="header-badge-text">HC AI</span>
            </div>
            <img class="custom-img" src="../../assets/img/lo.png" alt="" srcset="" />
            <!-- Add the session name display here -->
          </div>
        </div>
        <div class="header-right-controls">
          <!-- Header Right Section: Font Size, Notification & User Profile -->
          <div class="header-right-section">

            <!-- Font Size Control -->
            <div class="font-size-wrapper">
              <button class="font-size-btn" title="Adjust font size" (click)="toggleFontSizeDropdown($event)">
                <i class="bi bi-fonts"></i>
              </button>

              <!-- Font Size Dropdown -->
              <div class="font-size-dropdown" [class.active]="isFontSizeDropdownOpen">
                <div class="font-size-header">
                  <span>Font Size</span>
                </div>
                <div class="font-size-options">
                  @for (opt of fontSizeService.options; track opt) {
                    <button
                      class="font-size-option"
                      [class.active]="fontSizeService.selected === opt"
                      (click)="fontSizeService.select(opt)">
                      {{ fontSizeService.presets[opt].label }}
                    </button>
                  }
                </div>
              </div>
            </div>

            <!-- Notification Button & Dropdown -->
            <div class="notification-wrapper">
              <button class="notification-btn" title="Notifications" (click)="toggleNotificationDropdown($event)">
                <i class="bi bi-bell"></i>
                @if (hasUnreadNotification) {
                  <span class="notification-dot"></span>
                }
              </button>

              <!-- Notification Dropdown -->
              <div class="notification-dropdown" [class.active]="isNotificationDropdownOpen">
                <div class="notification-header">
                  <h5>What's New</h5>
                  <button class="notification-close-btn" (click)="closeNotificationDropdown()">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
                <div class="notification-body">
                  <p class="notification-date"><strong>Last Update:</strong> February 12, 2026</p>

                  <div class="notification-section">
                    <div class="notification-section-header">
                      <i class="bi bi-star"></i>
                      <strong>New Features:</strong>
                    </div>
                    <ul>
                      <li>UI Enhancements</li>
                      <li>Text Size Options</li>
                    </ul>
                  </div>

                  <div class="notification-section">
                    <div class="notification-section-header">
                      <i class="bi bi-circle"></i>
                      <strong>Upcoming:</strong>
                    </div>
                    <ul>
                      <li>Image Generation</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- User Profile Button & Dropdown -->
            @if (userDisplayName || userDisplayEmail) {
              <div class="user-profile-wrapper">
                <div class="user-avatar" (click)="toggleUserDropdown($event)">
                  @if (userProfilePicture) {
                    <img [src]="userProfilePicture" alt="Profile" class="profile-img" />
                  }
                  @if (!userProfilePicture) {
                    <span>{{ userInitials }}</span>
                  }
                </div>
                <!-- User Dropdown -->
                <div class="user-dropdown" [class.active]="isUserDropdownOpen">
                  <div class="user-dropdown-header">
                    <div class="user-dropdown-avatar">
                      @if (userProfilePicture) {
                        <img [src]="userProfilePicture" alt="Profile"
                          class="profile-img-large" />
                      }
                      @if (!userProfilePicture) {
                        <span>{{ userInitials }}</span>
                      }
                    </div>
                    <div class="user-dropdown-info">
                      <div class="user-dropdown-name">{{ userDisplayName }}</div>
                      <div class="user-dropdown-email">{{ userDisplayEmail }}</div>
                    </div>
                  </div>
                  <div class="user-dropdown-divider"></div>
                  <button class="user-dropdown-logout" (click)="logout()">
                    <i class="bi bi-box-arrow-right"></i>
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </nav>

      <!-- Image Generation Options (shown only when DALL-E is selected) -->
      @if (isDallESelected) {
        <div class="image-options-bar p-3 mb-2"
          style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 8px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
          <div class="row align-items-center">
            <div class="col-12 mb-2">
              <h6 class="mb-0 text-white"><i class="fa-solid fa-image"></i> DALL-E 3 Image Generation Options</h6>
            </div>
            <div class="col-md-4 col-sm-6 mb-2">
              <label class="form-label small mb-1 text-white">Size:</label>
              <select class="form-select form-select-sm" [(ngModel)]="imageSize">
                @for (size of imageSizes; track size) {
                  <option [value]="size.value">
                    {{ size.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col-md-4 col-sm-6 mb-2">
              <label class="form-label small mb-1 text-white">Quality:</label>
              <select class="form-select form-select-sm" [(ngModel)]="imageQuality">
                @for (quality of imageQualities; track quality) {
                  <option [value]="quality.value">
                    {{ quality.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col-md-4 col-sm-6 mb-2">
              <label class="form-label small mb-1 text-white">Style:</label>
              <select class="form-select form-select-sm" [(ngModel)]="imageStyle">
                @for (style of imageStyles; track style) {
                  <option [value]="style.value">
                    {{ style.label }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      }

      <div class="drop-zone" >

        <div class="main p-3" id="chat-container" >
          <!-- Warning banner for unavailable model -->


          @if (!isCurrentSessionModelAvailable && currentSessionId) {
            <div class="alert d-flex align-items-center mb-3"
            role="alert" style="background-color: rgba(255, 243, 205, 0.6); 
                          border-left: 3px solid rgba(255, 193, 7, 0.7); 
                          border-bottom: 1px solid rgba(255, 193, 7, 0.3);
                          border-radius: 4px;
                          padding: 0.5rem 1rem !important;
                          margin: 15px !important;
                          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);">
              <i class="bi bi-exclamation-circle me-2" style="font-size: 1rem; color: #856404; opacity: 0.8;"></i>
              <div class="flex-grow-1" style="margin-left: 10px !important;">
                <p class="mb-0 ml-2" style="font-size: 0.9rem; color: #856404;">
                  <strong>Model not available.</strong> Please open a new chat session.
                </p>
              </div>
            </div>
          }

          @if (chatHistory.length === 0) {
            <div
              style="flex: 1; max-width: 100% !important; background-color: transparent; box-shadow: none;">
              <div class="body-content d-flex flex-column justify-content-center align-items-center mt-2">
                <br /><br />
                <img src="assets/img/hc-logo-clean.png" alt="Logo" class="body-logo mb-4" />
                <h1 class="mb-2">Start Chatting</h1>
                <p>This chatbot is configured to answer your question</p>
              </div>
            </div>
          }
          @for (chat of chatHistory; track chat) {
            <div>
              <!-- User Message -->
              @if (chat.type === 'user') {
                <div class="message-row user-row">
                  <div class="message-content-wrapper">
                    <div class="message-header user-header">
                      <span class="message-sender">You</span>
                      <span class="message-timestamp">{{ chat.date }}</span>
                    </div>
                    <div class="message-bubble user-bubble" [style.font-size.px]="fontSizeService.currentSize">
                      @if (chat.file && chat.file.length > 0) {
                        <span>
                          @for (item of chat.file; track item) {
                            <div class="attached-file">
                              <i class="bi bi-file-earmark-check-fill"></i>
                              <span>{{ item.name }}</span>
                            </div>
                          }
                        </span>
                      }
                      <markdown [data]="chat.content | decodeHtmlEntities" [disableSanitizer]="false"></markdown>
                    </div>
                  </div>
                  <div class="avatar-wrapper user-avatar-wrapper">
                    <div class="avatar user-avatar">
                      @if (userProfilePicture) {
                        <img [src]="userProfilePicture" alt="Profile" class="profile-img-avatar">
                      }
                      @if (!userProfilePicture) {
                        <span class="user-initials">{{ userInitials }}</span>
                      }
                    </div>
                  </div>
                </div>
              }
              <!-- AI/GPT Message -->
              @if (chat.type === 'gpt' || chat.type === 'model') {
                <div class="message-row ai-row">
                  <div class="avatar-wrapper ai-avatar-wrapper">
                    <img class="avatar ai-avatar" src="assets/img/hc-logo-clean.png" alt="HarperCollins AI" />
                  </div>
                  <div class="message-content-wrapper">
                    <div class="message-header ai-header">
                      <span class="message-sender">HarperCollins AI</span>
                      <span class="message-timestamp">{{ chat.date }}</span>
                    </div>
                    <div class="message-bubble ai-bubble" [style.font-size.px]="fontSizeService.currentSize">
                      <!-- Typing indicator when content is empty and loading -->
                      @if (!chat.content && isLoading) {
                        <div class="typing-indicator">
                          <div class="typing-dot"></div>
                          <div class="typing-dot"></div>
                          <div class="typing-dot"></div>
                        </div>
                      }
                      <!-- Actual content -->
                      @if (chat.content) {
                        <markdown class="chat-response-content" [data]="chat.content | decodeHtmlEntities" [disableSanitizer]="false"></markdown>
                      }
                      <!-- Display generated image if available -->
                      @if (chat.imageUrl) {
                        <div class="generated-image-container">
                          <img [src]="chat.imageUrl" alt="Generated image" class="generated-image" />
                        </div>
                      }
                    </div>
                    @if (chat.content) {
                      <button class="copy-btn" (click)="copyMessage(chat.content)" title="Copy message">
                        <i class="bi" [ngClass]="copiedMessageIndex === chat ? 'bi-check2' : 'bi-copy'"></i>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <!-- Loading indicator removed as per user request -->
        </div>

        @if (isTokenLimitExceeded) {
          <div class="text-danger mt-1">
            Token limit exceeded (~4000 tokens). Please reduce input length.
          </div>
        }

        <!-- New Centered Input Design -->
        <div class="chat-input-wrapper"
          style="display: flex; flex-direction: column; align-items: center; width: 100%; padding: 16px 20px;">

          <!-- File Preview Chips - Above Info Bar -->
          @if (selectedFiles.length > 0) {
            <div class="file-preview-container">
              @for (file of selectedFiles; track file; let i = $index) {
                <div class="file-chip">
                  <div class="file-chip-icon">
                    <i class="bi bi-file-earmark"></i>
                  </div>
                  <div class="file-chip-info">
                    <span class="file-chip-name" [title]="file.name">{{ file.name }}</span>
                    <span class="file-chip-size">{{ formatFileSize(file.size) }}</span>
                  </div>
                  <button class="file-chip-remove" (click)="removeFile(i)" title="Remove file">
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              }
            </div>
          }

          <!-- Info Bar Above Input - GPT Models -->
          @if (selectdModel.includes('gpt')) {
            <div class="chat-input-info-bar">
              <div class="info-bar-left">
                <span class="supported-files-text">
                  <strong>Supported files: </strong> Images (JPEG, PNG, WEBP). For other file types, switch to one of the Gemini models.
                </span>
              </div>
              <div class="info-bar-right">
                <span class="available-token-text">
                  <strong>Available Tokens:</strong> {{ balanced_token }}
                </span>
              </div>
            </div>
          }

          <!-- Info Bar Above Input - Gemini Models -->
          @if (selectdModel.includes('gemini') && !selectdModel.includes('search')) {
            <div class="chat-input-info-bar">
              <div class="info-bar-left">
                <span class="supported-files-text">
                  <strong>Supported files: </strong> PDF, images (JPEG, PNG, WEBP), TXT, CSV, XLS, XLSX, DOCX
                </span>
              </div>
              <div class="info-bar-right">
                <span class="available-token-text">
                  <strong>Available Tokens:</strong> {{ balanced_token }}
                </span>
              </div>
            </div>
          }

          <!-- Input Row -->
          <div class="chat-input-row">
            <!-- Action Buttons (Globe + Attachment) -->
            <div class="input-actions-wrapper">
              <!-- Web Search Button -->
              @if (!selectdModel.includes('search')) {
                <button
                  class="btn-web-search"
                  [class.btn-web-search-disabled]="selectdModel.includes('gpt') || selectdModel.includes('dall')"
                  [disabled]="true" type="button">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.9851 4.00291C11.9933 4.00046 11.9982 4.00006 11.9996 4C12.001 4.00006 12.0067 4.00046 12.0149 4.00291C12.0256 4.00615 12.047 4.01416 12.079 4.03356C12.2092 4.11248 12.4258 4.32444 12.675 4.77696C12.9161 5.21453 13.1479 5.8046 13.3486 6.53263C13.6852 7.75315 13.9156 9.29169 13.981 11H10.019C10.0844 9.29169 10.3148 7.75315 10.6514 6.53263C10.8521 5.8046 11.0839 5.21453 11.325 4.77696C11.5742 4.32444 11.7908 4.11248 11.921 4.03356C11.953 4.01416 11.9744 4.00615 11.9851 4.00291ZM8.01766 11C8.08396 9.13314 8.33431 7.41167 8.72334 6.00094C8.87366 5.45584 9.04762 4.94639 9.24523 4.48694C6.48462 5.49946 4.43722 7.9901 4.06189 11H8.01766ZM4.06189 13H8.01766C8.09487 15.1737 8.42177 17.1555 8.93 18.6802C9.02641 18.9694 9.13134 19.2483 9.24522 19.5131C6.48461 18.5005 4.43722 16.0099 4.06189 13ZM10.019 13H13.981C13.9045 14.9972 13.6027 16.7574 13.1726 18.0477C12.9206 18.8038 12.6425 19.3436 12.3823 19.6737C12.2545 19.8359 12.1506 19.9225 12.0814 19.9649C12.0485 19.9852 12.0264 19.9935 12.0153 19.9969C12.0049 20.0001 11.9999 20 11.9999 20C11.9999 20 11.9948 20 11.9847 19.9969C11.9736 19.9935 11.9515 19.9852 11.9186 19.9649C11.8494 19.9225 11.7455 19.8359 11.6177 19.6737C11.3575 19.3436 11.0794 18.8038 10.8274 18.0477C10.3973 16.7574 10.0955 14.9972 10.019 13ZM15.9823 13C15.9051 15.1737 15.5782 17.1555 15.07 18.6802C14.9736 18.9694 14.8687 19.2483 14.7548 19.5131C17.5154 18.5005 19.5628 16.0099 19.9381 13H15.9823ZM19.9381 11C19.5628 7.99009 17.5154 5.49946 14.7548 4.48694C14.9524 4.94639 15.1263 5.45584 15.2767 6.00094C15.6657 7.41167 15.916 9.13314 15.9823 11H19.9381Z"
                    fill="currentColor"></path>
                  </svg>
                  <span class="web-search-tooltip">{{ selectdModel.includes('gemini') ? 'Web search enabled' : 'Web search not supported' }}</span>
                </button>
              }

              <!-- Attachment Button with Popover -->
              @if (!selectdModel.includes('search')) {
                <div class="attachment-btn-container">
                  <button type="button" #popoverBtn (click)="togglePopover()" class="btn-attachment"
                    [disabled]="isLoading || !isCurrentSessionModelAvailable" title="Attach file">
                    <i class="bi bi-paperclip"></i>
                  </button>
                  <!-- Popover for file selection -->
                  @if (isPopoverOpen) {
                    <div class="attachment-popover" cdkTrapFocus>
                      <div class="attachment-popover-content">
                        @if (selectdModel.includes('gemini')) {
                          <p (click)="fileInput.click(); isPopoverOpen = false"
                            class="attachment-option">
                            <i class="bi bi-file-earmark-plus-fill"></i>
                            <span>Select File</span>
                          </p>
                        }
                        @if (selectdModel.includes('gpt')) {
                          <p (click)="fileInput1.click(); isPopoverOpen = false"
                            class="attachment-option">
                            <i class="bi bi-file-earmark"></i>
                            <span>Select Files</span>
                          </p>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Hidden file inputs -->
            <input accept=".jpg,.jpeg,.png,.webp,.pdf,.txt,.csv,.xls,.xlsx,.docx" multiple #fileInput type="file"
              (change)="onFileSelected($event)" style="display: none" />
            <input accept=".jpg,.jpeg,.png,.webp" multiple #fileInput1 type="file" (change)="onFileSelected($event)"
              style="display: none" />
            <input accept=".pdf" multiple #fileInput2 type="file" (change)="onFileSelected($event)"
              style="display: none" />

            <button id="clearall" style="display: none" (click)="clearAll(fileInput, fileInput1, fileInput2)">
              Clear Chat & Files
            </button>

            <!-- Chat Input Container (Center) -->
            <div class="chat-input-container">
              <textarea (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                id="myTextArea" #myTextArea autofocus [placeholder]="
                    !isCurrentSessionModelAvailable ? ' ' : 
                    (selectedFiles.length > 0 ? '' : 'Type a new question...')
                  " class="chat-textarea" [(ngModel)]="userPrompt"
                [disabled]="isLoading || !isCurrentSessionModelAvailable" (keydown)="handleKeyDown($event)"
              (input)="autoResizeTextarea($event)" rows="1"></textarea>
            </div>

            <!-- Send Button (Outside Right) -->
            <button type="button" (click)="sendPrompt()"
              [disabled]="isLoading || isTokenLimitExceeded || !userPrompt.trim() || !isCurrentSessionModelAvailable"
              class="btn-send"
              [title]="!isCurrentSessionModelAvailable ? 'Model not available for this session' : 'Send message'">
              <i class="bi bi-send-fill"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (showComponent) {
    <app-citation [content]="selectedContent"></app-citation>
  }

  <app-feedback-popup></app-feedback-popup>

  <!-- Changelog Toggle Button (Bottom Left) -->
  <!-- <button
  class="changelog-toggle-btn"
  (click)="toggleChangelog()"
  [title]="isChangelogOpen ? 'Minimize Changelog' : 'Expand Changelog'"
  >
  <i class="bi" [ngClass]="isChangelogOpen ? 'bi-dash-lg' : 'bi-megaphone'"></i>
</button> -->

<!-- Changelog Popup -->
<!-- <div class="changelog-popup" [ngClass]="{ 'active': isChangelogOpen }">
<div class="changelog-header">
  <h5>What's New</h5>
  <button class="changelog-close-btn" (click)="toggleChangelog()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="changelog-content">
  <p class="changelog-date"><strong>Last Update:</strong> Feb 6, 2026</p>

  <div class="changelog-section">
    <h6><i class="bi bi-star-fill"></i> New Features:</h6>
    <ul>
      <li>UI enhancements</li>
    </ul>
  </div>

  <div class="changelog-section">
    <h6><i class="bi bi-clock-history"></i> Upcoming:</h6>
    <ul>
      <li>Image Generation</li>
    </ul>
  </div>
</div>
</div> -->
</div>
